{
  "upload": {
    "choose": "Choose a file",
    "inProgress": "Uploading…",
    "hint": "{{limitValue}} MB maximum per file.",
    "replace": "Replace"
  },
  "errors": {
    "type": "This format is not accepted here. Accepted formats: {{accepted}}.",
    "tooLarge": "This file exceeds the maximum size of {{limitValue}} MB."
  },
  "cover": {
    "title": "Cover image",
    "hint": "Shown in the public catalogue. JPEG, PNG or WebP.",
    "add": "Add a cover",
    "remove": "Remove the cover",
    "alt": "Course cover"
  },
  "resource": {
    "download": "Download",
    "pdf": "PDF document",
    "image": "Image"
  },
  "files": {
    "title": "My files",
    "empty": "No files yet.",
    "delete": "Delete",
    "size": "{{sizeValue}} MB"
  }
}
